import {fade} from 'svelte/transition'
export function getLang(lang) {

    if (typeof lang === "undefined" || lang === null) {
        return "en";
    } else {
        if (lang.length > 3) {
            lang = lang.substring(0, 2);
        }
        switch (lang) {
            case "es":
            case "fr":
            case "pt":
            case "ru":
            case "cn":
            case "zh":
            case "id":
            case "it":
            case "de":
            case "jp":
                break;
            case "ja":
                lang = "jp";
                break;
            default:
                lang = "en";

        }
        return lang;
    }
}
export function shareUrl(url){
    console.log('share '+ url)
    navigator.share({
        url: url
    })
    .then(() => console.log('Successful share'))
    .catch((error) => console.log('Error sharing', error));
}

export function A2HimhError(img) {
    img.onerror = "";
    img.src = "https://igstatic.azureedge.net/users/mobile/site/Icon-144x144.png";
    return true;

}

export function A2HimhErrorPre(img) {
    img.onerror = "";
    img.src = "https://igstatic.azureedge.net/users/mobile/site/apple-touch-icon-precomposed.png";
    return true;

}

export function checkImagesReady(imagesNeeded){

   
    return imagesNeeded.length === imagesNeeded.filter(x=> x===true).length;
    
    
}

export function imageLoaded(imagesNeeded,index){
    console.log(imagesNeeded);
    console.log(index);
    imagesNeeded[index] = true;
    if(checkImagesReady(imagesNeeded)){
        showApp()
    }
}

// function showApp(){

//    console.log('All needed images loaded');

 
//     document.getElementById('splash').classList.add('app-ready');
//     document.getElementsByClassName('a2h-container')[0].style.display='block';
    
//    //fade(document.getElementsByClassName('a2h-container')[0],250);
   

// }

export function preload(url){
   return fetch(url, {"credentials":"omit","headers":{"sec-fetch-mode":"no-cors","sec-fetch-site":"cross-site"},"referrer":"http://localhost:5000/","referrerPolicy":"no-referrer-when-downgrade","body":null,"method":"GET","mode":"cors"});
}